<template>
    <div role="status" class="animate-pulse">
        <div class="h-12 bg-gray-200 rounded-lg dark:bg-gray-700 mb-4"></div>
        <div class="h-10 bg-gray-200 rounded-full dark:bg-gray-700 max-w-md my-7"></div>
        <div class="h-10 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5 max-w-md my-5"></div>
        <div class="flex gap-2 h-28 mt-72">
            <div class="h-10 bg-gray-200 w-1/2 rounded-lg max-w-44"></div>
            <div class="h-10 bg-gray-200 w-1/2 rounded-lg max-w-44"></div>
        </div>
        <span class="sr-only">Loading...</span>
    </div>
</template>